export function createEstablishmentUserObject() {
    return {
        userId: '',
        establishmentId: '',
        establishmentUserRole: '',
        operationType: ''

    };
}


/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentUserObject.js
 **/